/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyReplacementRowStatus {
    NO_CHANGE = 'noChange',
    NEW = 'new',
    VENDOR_CHANGE = 'vendorChange',
    USER_CHANGE = 'userChange',
    UNMAPPED = 'unmapped',
    USER_SKIP = 'userSkip',
    UNKNOWN = 'unknown',
}
